module.exports = "/_next/static/images/search_bg_22-8f127cd4a912d80eda97b3a4547a9293.jpg";